import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Pinned from '../../assets/images/Pinned.svg';
import { tA11y } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

const PinnedIcon = (): React.ReactElement => {
  const classes = useStyles();

  return <img src={Pinned} className={classes.pin} alt={`${tA11y('alt.pinIcon')}`} />;
};

const useStyles = makeStyles(() => ({
  pin: {
    width: '90%',
  },
}));

export default PinnedIcon;
